import { beginRowRegexp, newLineRegex } from '@anm/constants/regex';

export const newLineToBr = (t: string) => {
  const processedText = t.replace(newLineRegex, `<br/>`);

  return processedText;
};

export const brToNewLine = (text: string) => text.replace(beginRowRegexp, '\n');
